import React, { useContext } from 'react'
import { ButtonContainer, ButtonDiv, CloseDiv, Container, Header, InfosContainer, RowDatas } from './style'
import close from '../../../assets/close-icon.svg'
import ModalContext from '../../../contexts/ModalContext'
import { MachineContext, MachineObjectType } from '../../../contexts/MachineContext'
import { fieldsAndValues } from '../CreateMachineModal/utils'
import pencil from '../../../assets/productions/pencil.svg'

const CheckMachineModal:React.FC = () => {
  const { setModalActive, setModalSection } = useContext(ModalContext)
  const { machine } = useContext(MachineContext)
  
  const formatDate = (dateString: string) => {
    const date = new Date(dateString)
    const day = String(date.getDate()).padStart(2, '0')
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const year = date.getFullYear()
  
    return `${day}/${month}/${year}`
  }

  const handleEdit = () => {
    setModalActive(true)
    setModalSection('editMachine')
  }
  
  return(
    <Container>
      <Header>
        <h2>Máquina: {machine?.identification}</h2>
        <CloseDiv onClick={() => (setModalActive(false))}>
          <img src={close} />
        </CloseDiv>
      </Header>
      <InfosContainer>
        {fieldsAndValues.map((item, index) => (
          <RowDatas key={index}>
            {item.label}
            <span>
              {item.type === 'cash' &&
                <>R$ {Number(machine[item.value]).toFixed(2).replace('.',',')}</>
              }
              {item.type === 'date' &&
                <>{formatDate(machine[item.value])}</>
              }
              {!['date','cash'].includes(item.type) && 
                <>{machine[item.value]}</>
              }
            </span>
          </RowDatas>
        ))}
      </InfosContainer>
      <ButtonContainer>
        <ButtonDiv onClick={() => handleEdit()}>
          <img src={pencil} />
          Editar máquina
        </ButtonDiv>
      </ButtonContainer>
    </Container>
  )
}

export default CheckMachineModal